<section class="content">
  <div class="container-fluid">
      <div class="block-header">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul class="breadcrumb breadcrumb-style ">
                <li class="breadcrumb-item">
                  <h4 class="page-title">Basic Form</h4>
                </li>
                <li class="breadcrumb-item bcrumb-1">
                  <a routerLink="/dashboard/main">
                    <i class="fas fa-home"></i> Home</a>
                </li>
                <li class="breadcrumb-item bcrumb-2">
                  <a href="#" onClick="return false;">Forms</a>
                </li>
                <li class="breadcrumb-item active">Basic</li>
              </ul>
            </div>
          </div>
        </div>
      <app-maser-page-header></app-maser-page-header>
    <div class="row" style="max-width: 1000px;    margin-top: 35px;">
      <div class="col-3">
        <mat-form-field>
          <mat-label style="border: none">Choose a date</mat-label>
          <input #date [ngModel]="default_date" style="border: none" matInput [matDatepicker]="picker">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <br>
        {{date.value | date: 'EEE-MMM-yyyy'}}
      </div>

      <div class="col-3">
        <div class="form-row" style="max-width: 200px">
          <label>Session <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <select #session_id class="form-control">
            <option *ngFor="let session of sessions" [value]="session['id']">{{session['name']}} </option>
          </select>
        </div>
      </div>

      <div class="col-3">
        <div class="form-row align-bottom" style="max-width: 200px">
          <input type="text" class="form-control" #business_code placeholder="Booth code">
        </div>
      </div>

      <div class="col-3">
        <button mat-raised-button color="primary" (click)="getBill(business_code.value, session_id.value, date.value)">
          Confirm
        </button>
      </div>
    </div>
  </div>

  <hr>
  <div class="row" *ngIf="is_sales_data_available" style="max-width: 800px">

    <!--      left side-->
    <div class="col-6">
      <div class="row">
        <div class="col-3">Route:</div>
        <div class="col-5">{{sales['route_name']}}</div>
      </div>
      <div class="row">
        <div class="col-3">booth code:</div>
        <div class="col-5">{{sales['business_code']}}</div>
      </div>
      <div class="row">
        <div class="col-3">Agent:</div>
        <div class="col-5">{{sales['agent_first_name']}}({{sales['agent_code']}})</div>
      </div>
    </div>

    <!--      right side-->
    <!--      super visor name-->
    <div class="col-6">
      <div class="row">
        <div class="col-5">Route Supervisor:</div>
        <div class="col">{{sales['route_supervisor']}}</div>
      </div>
      <!--      route name-->
      <div class="row">
        <div class="col-3">Date:</div>
        <div class="col-5">{{sales['date'] | date: 'dd-MM-yyyy'}}/{{sales['session']}}</div>
      </div>
    </div>
  </div>

  <table class="table table-hover table-bordered" *ngIf="is_sales_data_available" style="max-width: 800px">
    <thead class="thead-dark">
    <tr style="width: 100%">
      <th scope="col">S.No.</th>
      <th scope="col">Product</th>
      <th scope="col">Agent Order<br>(Cash)</th>
      <th scope="col">Family Card<br>(Card)</th>
      <th scope="col">Trays</th>
      <th scope="col">Pkts</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let product_id of product_ids; let product_index=index">
      <th scope="row">{{product_index + 1}}</th>
      <td>{{sales['sales'][product_id]['product_short_name']}} {{sales['sales'][product_id]['product_unit']}}</td>
      <td>{{sales['sales'][product_id]['count']}}</td>
      <td>{{sales['sales'][product_id]['icustomer_count']}}</td>
      <td>{{sales['sales'][product_id]['calculated_tray_count']}}</td>
      <td>{{sales['sales'][product_id]['calculated_pocket_count']}}</td>
      <td>{{sales['sales'][product_id]['leak_packet']}}</td>
      <td>{{sales['sales'][product_id]['litre']}}</td>
    </tr>
    <tr>
      <th></th>
      <th>Cash Sales Rs:</th>
      <td>{{sales['total_cost']}}</td>
<!--      <td>{{sales['total_tray_count']}}</td>-->
<!--      <td>{{sales['total_packet_count']}}</td>-->
<!--      <td>{{sales['total_leak_packet_count']}}</td>-->
<!--      <td>{{sales['total_litre_count']}}</td>-->
    </tr>
    </tbody>
  </table>
</section>
